var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleAdjustment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 2.16667H2.33333C1.59695 2.16667 1 2.76362 1 3.5V12.1667C1 12.903 1.59695 13.5 2.33333 13.5H5M4.33333 2.16667H9.66667M4.33333 2.16667V1.5M4.33333 2.16667V2.83333M9.66667 2.16667H11.6667C12.403 2.16667 13 2.76362 13 3.5V6.16667M9.66667 2.16667V1.5M9.66667 2.16667V2.83333M1.66667 4.83333H12.3333M10.6667 10.1667L12 11.5M9.002 15.002H7.33533V13.3353L12.3353 8.33533L14.002 10.002L9.002 15.002ZM7 10.5H7.002V10.502H7V10.5ZM4.33333 10.5H4.33533V10.502H4.33333V10.5ZM9.66667 7.83333H9.66867V7.83533H9.66667V7.83333ZM7 7.83333H7.002V7.83533H7V7.83333ZM4.33333 7.83333H4.33533V7.83533H4.33333V7.83333Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleAdjustment);
export default __webpack_public_path__ + "static/media/scheduleAdjustment.c0b3aaf6530eb08b06ce48903b8839d4.svg";
export { ForwardRef as ReactComponent };